import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from 'utils/api'
import { buildUrl } from 'utils/helpers'

const STORAGE_KEY = 'admin_acting_partner'

const loadPersistedPartner = () => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

const persistedPartner = loadPersistedPartner()
if (persistedPartner?.uuid) {
  api.setActingPartner(persistedPartner.uuid)
}

export const fetchPartnersByAccount = createAsyncThunk(
  'admin/fetchPartnersByAccount',
  async ({ personalAccount, serialNumber, uuid } = {}, { rejectWithValue }) => {
    try {
      const payload = await api.request(
        buildUrl('/admin/service_partners', {
          personal_account: personalAccount || undefined,
          serial_number: serialNumber || undefined,
          uuid: uuid || undefined,
        })
      )
      return payload.data
    } catch (err) {
      return rejectWithValue('Не удалось загрузить список партнёров')
    }
  }
)

const adminSlice = createSlice({
  name: 'admin',
  initialState: {
    actingPartner: persistedPartner,
    partners: [],
    loading: false,
  },
  reducers: {
    setActingPartner(state, action) {
      state.actingPartner = action.payload
      api.setActingPartner(action.payload?.uuid || null)
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(action.payload))
        // eslint-disable-next-line no-empty
      } catch {}
    },
    clearActingPartner(state) {
      state.actingPartner = null
      api.setActingPartner(null)
      try {
        sessionStorage.removeItem(STORAGE_KEY)
        // eslint-disable-next-line no-empty
      } catch {}
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartnersByAccount.pending, (state) => {
        state.loading = true
        state.partners = []
      })
      .addCase(fetchPartnersByAccount.fulfilled, (state, action) => {
        state.loading = false
        state.partners = action.payload
      })
      .addCase(fetchPartnersByAccount.rejected, (state) => {
        state.loading = false
      })
  },
})

export const { setActingPartner, clearActingPartner } = adminSlice.actions
export default adminSlice.reducer
